import { render, staticRenderFns } from "./waiting-reversal.vue?vue&type=template&id=ec05d8be&scoped=true"
import script from "./waiting-reversal.vue?vue&type=script&lang=js"
export * from "./waiting-reversal.vue?vue&type=script&lang=js"
import style0 from "./waiting-reversal.vue?vue&type=style&index=0&id=ec05d8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec05d8be",
  null
  
)

export default component.exports